(function () {
  'use strict';

  angular.module('app').component('debitNoteDetail', debitNoteDetail());

  function debitNoteDetail() {
    return {
      bindings: {
        item: '<',
        mode: '<',
        showActionsFromModal: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
      },
      controller: DebitNoteDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/debit-notes/debit-note-detail/debit-note-detail.component.html',
    };
  }

  DebitNoteDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'SessionService',
    'AbilityService',
    'moment',
    'DebitNoteService',
    'InvoiceService',
    'CreditNoteService',
    'ClientService',
    'TaxService',
    'DocumentTypeService',
    'MeasurementUnitService',
    'DocumentService',
    'ModalWindowConfirmService',

    // Angular downgraded service
    'companyService',
  ];

  function DebitNoteDetailComponent(
    config,
    UtilService,
    SessionService,
    AbilityService,
    moment,
    DebitNoteService,
    InvoiceService,
    CreditNoteService,
    ClientService,
    TaxService,
    DocumentTypeService,
    MeasurementUnitService,
    DocumentService,
    ModalWindowConfirmService,

    // Angular downgraded service
    companyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_debitnote_accountadmin'),
      canUpdate: AbilityService.can('update_debitnote_accountadmin'),
    };

    vm.dateDisplay = config.DATE_DISPLAY;

    vm.statusDraft = 'draft';
    vm.statusProcessed = 'processed';
    vm.statusAccepted = 'accepted';
    vm.statusSent = 'sent';

    // private properties
    // -----------------------
    let company = SessionService.getSelectedAccountCompany();

    vm.$onInit = function () {
      vm.atvCrEnabled = company.atv_cr_enabled;

      if (vm.item.id) {
        // view - edit
        if (!vm.item.user_id) {
          vm.item.user_id = SessionService.currentUser().id;
        }

        vm.isElectronicDocument = vm.item.document_type.numbering_type === 'electronic';

        setItemOptions(vm.item, vm.mode);

        // vm.documentDate = moment(vm.item.date);
        vm.documentDate = vm.UtilService.startOfDayFormat(vm.item.date); // yyyy-mm-ddT06:00:00.000Z
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          date: moment(),
          debit_note_reference: {},
          debit_note_products: [],
          payment_method_codes: [],
          company_id: company.id,
          user_id: SessionService.currentUser().id,
        };

        // Initializers
        getDocumentTypes();

        vm.documentDate = moment();
      }

      // Initializers
      getCompany();
    };

    // public methods
    // -----------------------

    // Atv functions
    vm.resendDocumentToAtv = function () {
      vm.loadingDocument = true;
      DocumentService.resendDocumentToAtv(vm.item, 'debit_notes').then(function (data) {
        if (data) {
          vm.item.atv_status = data.atv_status || vm.item.atv_status; // Important if no atv status sent
        }

        vm.loadingDocument = false;
      });
    };

    vm.isInvalidHeader = function () {
      if (vm.viewMode) return false;

      return !!(
        vm.sendingForm ||
        !(
          vm.item.client_id &&
          vm.item.transaction_id &&
          vm.item.debit_note_reference.reference_code &&
          vm.item.user_id &&
          vm.item.date
        )
      );
    };

    vm.selectDocumentType = function (documentType) {
      if (vm.editMode && vm.isAnAutomaticNumberingType) {
        let params = {
          title: 'CHANGE_DOCUMENT_TYPE',
          body: 'A_DOCUMENT_WITH_AUTOMATIC_NUMBERING_CANNOT_BE_CHANGED',
          mode: 'warning',
        };

        ModalWindowConfirmService.open(params);

        vm.item.document_type_id = vm.lastDocumentType.id;
        vm.item.document_type = vm.lastDocumentType;

        return;
      }

      if (documentType.id === vm.lastDocumentTypeId) return;
      vm.documentType = documentType;
      vm.lastDocumentTypeId = documentType.id;
      vm.item.document_type_id = documentType.id;
      vm.item.document_type = vm.documentType;

      vm.isAnAutomaticNumberingType = documentType.numbering_type === 'automatic';

      setDebitNoteDatePicker(vm.documentType);
    };

    vm.onClientSelected = function (client) {
      let selectClientCallback = function () {
        vm.lastClientId = client.id;
        vm.item.client_id = client.id;
        vm.item.client = client;

        getTransactions(client.id);
      };

      // Delete debit note products for draft debit note if change client, when the debit note has debit note products
      if (vm.lastClientId && client.id !== vm.lastClientId) {
        let successCallback = function () {
          resetDebitNoteData();

          selectClientCallback();

          return;
        };

        let cancelCallback = function () {
          // Just to keep current client
          vm.item.client_id = vm.lastClientId;
        };

        let modalParams = {
          title: 'CHANGE_CLIENT_FOR_CURRENT_DEBIT_NOTE',
          body: 'CHANGE_CLIENT_FOR_CURRENT_DEBIT_NOTE_WARNING',
        };

        vm.UtilService.warningMsg(modalParams, successCallback, cancelCallback);
      } else {
        // In case the user change the client
        if (vm.lastClientId && client.id !== vm.lastClientI) {
          vm.item.debit_note_products = [];
        }

        selectClientCallback();
      }
    };

    // When client is empty
    vm.onClientValidated = function (client) {
      vm.item.client = client;

      if (!vm.item.client && vm.item.client_id) {
        resetClientInput();
      }
    };

    vm.onClientCleared = function (clearObj) {
      if (clearObj) {
        vm.item.client = null;
      }

      resetClientInput();
    };

    vm.selectDebitNoteReason = function (referenceCode) {
      vm.referenceCode = referenceCode;
      vm.item.debit_note_reference.reference_reason = referenceCode.name;

      vm.item.edit_allowed = referenceCode.code === '01' ? false : referenceCode.allow_edit;
    };

    vm.selectOpenTransaction = function (transactionSelected) {
      // Same open invoice selected
      if (vm.lastTransactionId === transactionSelected.id) return;

      const serviceType = transactionSelected.invoice_number
        ? InvoiceService.getInvoice
        : CreditNoteService.getCreditNote;

      vm.allProductsCabysCodeSet = true;

      vm.loadingDebitNoteProducts = true;
      serviceType(transactionSelected.id).then(function (transaction) {
        vm.lastTransactionId = transaction.id;

        vm.item.unit_price_type = transaction.unit_price_type;

        vm.item.subtotal_services_taxable = transaction.subtotal_services_taxable;
        vm.item.subtotal_services_exempt = transaction.subtotal_services_exempt;
        vm.item.subtotal_services_exonerable = transaction.subtotal_services_exonerable;
        vm.item.subtotal_goods_taxable = transaction.subtotal_goods_taxable;
        vm.item.subtotal_goods_exempt = transaction.subtotal_goods_exempt;
        vm.item.subtotal_goods_exonerable = transaction.subtotal_goods_exonerable;

        vm.item.total_taxable = transaction.total_taxable;
        vm.item.total_exempt = transaction.total_exempt;
        vm.item.total_exonerable = transaction.total_exonerable;
        vm.item.total_sale = transaction.total_sale;
        vm.item.total_discount = transaction.total_discount;
        vm.item.total_net_sale = transaction.total_net_sale;

        vm.item.total_taxes = transaction.total_taxes;
        vm.item.total_tax_exonerations = transaction.total_tax_exonerations;
        vm.item.total_net_taxes = transaction.total_net_taxes;
        vm.item.total_retornable_taxes = transaction.total_retornable_taxes;
        vm.item.total_other_charges = transaction.total_other_charges;
        vm.item.grand_total = transaction.grand_total;

        vm.item.user_id = transaction.user_id || SessionService.currentUser().id;
        vm.item.sale_channel_id = transaction.sale_channel_id;
        vm.item.sale_source_id = transaction.sale_source_id;
        vm.item.sale_condition_code = transaction.sale_condition_code;
        vm.item.payment_method_code = transaction.payment_method_code;
        vm.item.payment_method_id = transaction.payment_method_id;
        vm.item.credit_payment_days = transaction.credit_payment_days;

        vm.item.invoice_id = transaction.invoice_number ? transaction.id : null;
        vm.item.transaction_type = transaction.invoice_number ? 'invoice' : 'credit_note';
        vm.item.credit_note_id = transaction.credit_note_number ? transaction.id : null;
        vm.item.currency_id = transaction.currency_id;
        vm.item.currency = transaction.currency;
        vm.item.debit_note_products = [];

        vm.item.exchange_rate_value = transaction.exchange_rate_value;
        vm.item.base_currency_symbol = transaction.base_currency_symbol;

        vm.item.debit_note_reference = {
          reference_doc_type: transaction.type,
          reference_date: transaction.date,
          reference_number: transaction.invoice_number
            ? transaction.invoice_number
            : transaction.credit_note_number,
          reference_key: transaction.atv_cr_key,
        };

        if (vm.item.sale_condition_code) {
          vm.saleCondition = vm.company.sale_conditions.find(
            (item) => item.code === vm.item.sale_condition_code
          );
        }

        const transactionProducts = transaction.invoice_products
          ? transaction.invoice_products
          : transaction.credit_note_products;

        transactionProducts.forEach(function (product) {
          let measurementUnit = vm.company.measurement_units.find(
            (item) => item.id === product.measurement_unit_id
          );

          let debitNoteProduct = {
            product_id: product.product_id,
            product_code: product.product_code,
            product_cabys_code: product.product_cabys_code,
            product_name: product.product_name,
            product_type: product.product_type,

            quantity: product.quantity,
            unit_price: product.unit_price,
            total_amount: product.total_amount,
            discount_percentage: product.discount_percentage,
            discount_amount: product.discount_amount,
            subtotal_price: product.subtotal_price,

            tax_percentage: product.tax_percentage,
            tax_amount: product.tax_amount,
            tax_exoneration_percentage: product.tax_exoneration_percentage,
            tax_exoneration_amount: product.tax_exoneration_amount,
            net_tax_percentage: product.net_tax_percentage,
            net_tax_amount: product.net_tax_amount,
            total_price: product.total_price,

            remarks: product.remarks,

            measurement_unit_id: product.measurement_unit_id,
            measurement_unit_symbol: product.measurement_unit_symbol,
            measurement_unit: measurementUnit,

            transaction_taxes: product.transaction_taxes,

            product: product.product,
          };

          if (vm.atvCrEnabled && vm.isElectronicDocument && !debitNoteProduct.product_cabys_code) {
            vm.allProductsCabysCodeSet = false;
          }

          vm.item.debit_note_products.push(debitNoteProduct);
        });

        vm.loadingDebitNoteProducts = false;
      });
    };

    vm.openClientInfoModal = function (client) {
      ClientService.openClientInfoModal(client);
    };

    vm.editDebitNoteProductRemarks = function (debitNoteProduct) {
      vm.debitNoteProduct = debitNoteProduct;
    };

    vm.calculateDebitNoteProductTotalPrice = function (debitNoteProduct) {
      debitNoteProduct.quantity = debitNoteProduct.quantity || 1;
      debitNoteProduct.tax_percentage = debitNoteProduct.tax_percentage || 0;

      let unitPrice = 0; // '' 0
      let discountPercentage = 0;

      if (vm.item.unit_price_type) {
        unitPrice = debitNoteProduct.unit_price; // || 0
        discountPercentage = debitNoteProduct.discount_percentage || 0;
      } else {
        debitNoteProduct.total_price = debitNoteProduct.total_price || 0;

        //  Unit price is calculated as Total divided by quantity before taxes
        let basePrice = debitNoteProduct.total_price / (debitNoteProduct.tax_percentage / 100 + 1); // vm.UtilService.roundNum(

        unitPrice = basePrice / debitNoteProduct.quantity;
      }

      let totalAmount = debitNoteProduct.quantity * unitPrice;
      let discountAmount = totalAmount * (discountPercentage / 100);
      let subtotalPrice = totalAmount - discountAmount;

      let taxAmount = TaxService.getProductTaxesTotalAmount(debitNoteProduct.transaction_taxes);
      let taxExonerationAmount = TaxService.getProductTaxesTotalExonerationAmount(
        debitNoteProduct.transaction_taxes
      );
      let netTaxAmount = taxAmount - taxExonerationAmount;

      if (unitPrice) {
        debitNoteProduct.unit_price = vm.UtilService.roundNum(unitPrice);
      }

      debitNoteProduct.total_amount = vm.UtilService.roundNum(totalAmount);
      debitNoteProduct.discount_percentage = discountPercentage;
      debitNoteProduct.discount_amount = vm.UtilService.roundNum(discountAmount);
      debitNoteProduct.subtotal_price = vm.UtilService.roundNum(subtotalPrice);

      debitNoteProduct.tax_amount = vm.UtilService.roundNum(taxAmount);
      debitNoteProduct.tax_exoneration_amount = vm.UtilService.roundNum(taxExonerationAmount);
      debitNoteProduct.net_tax_amount = vm.UtilService.roundNum(netTaxAmount);

      if (vm.item.unit_price_type) {
        debitNoteProduct.total_price = vm.UtilService.roundNum(subtotalPrice + netTaxAmount); // taxAmount
      }

      calculateDebitNoteTotals();
    };

    vm.editDebitNote = function () {
      vm.editMode = true;
      vm.viewMode = false;
      getDocumentTypes();
    };

    vm.saveDebitNote = function (isFormValid, status) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      if (!vm.allProductsCabysCodeSet) return;

      let createDebitNote = function () {
        if (vm.item.payment_method_code) {
          vm.item.payment_method_codes.push(vm.item.payment_method_code);
        }

        vm.item.status = status;

        let debitNote = setDebitNoteParams();

        vm.sendingForm = true;
        DebitNoteService.saveDebitNote(debitNote).then(function (data) {
          let status = data.status;
          let response = data.response;

          if (status) {
            // success
            if (!vm.editMode) {
              // create
              vm.onSavedItem({ item: response });
            } else {
              setItemOptions(response);
            }
            vm.isElectronicDocument = vm.item.document_type.numbering_type === 'electronic';
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.UtilService.scrollToTop();

          vm.sendingForm = false;
        });
      };

      vm.item.client_email_receipt = vm.item.client.email;

      createDebitNote();
    };

    vm.cancel = function () {
      const successCallback = () => {
        vm.onCanceledItem();
      };

      const cancelCallback = () => {
        return;
      };

      if (vm.viewMode) {
        successCallback();
        return;
      }

      let modalParams = {
        mode: 'warning',
        title: 'CANCELLING_WILL_DELETE_THIS_FORM_ARE_YOU_SURE',
        confirmButtonLabel: 'YES',
        cancelButtonLabel: 'NO',
        body: '',
      };

      ModalWindowConfirmService.open(modalParams, successCallback, cancelCallback);
    };

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editDebitNote();
      }

      vm.originalItem = angular.copy(item); // store server data
    }

    // Initializers
    function getCompany() {
      vm.loadingCurrenciesPerCompany = true;

      let userLanguageCode = SessionService.getUserLanguage().code;

      vm.loadingCompany = true;
      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: userLanguageCode,
        })
        .subscribe((response) => {
          vm.company = response;

          vm.companyBaseCurrencyId = vm.company.currency_id;
          vm.companyCurrencyIds = vm.company.currency_ids;

          if (vm.company.country.country_setting) {
            vm.company.credit_note_reference_codes =
              vm.company.country.country_setting.credit_note_reference_codes;
          }

          if (vm.createMode) {
            vm.companyActivityCode = vm.company.activity_codes.find(
              (activity_code) => activity_code.id === vm.company.company_activity_code_id
            );
            vm.item.company_activity_code = vm.companyActivityCode.code;
          } else {
            // View / Edit
            setCompanyActivityCode(vm.company);

            if (vm.editMode) {
              vm.item.currency_id = vm.item.client.currency_id
                ? vm.item.client.currency_id
                : vm.companyBaseCurrencyId;
              // vm.item.currency = vm.currenciesPerCompany.find((x) => x.id === vm.item.currency_id);
            }

            vm.saleCondition = vm.company.sale_conditions.find(
              (x) => x.code === vm.item.sale_condition_code
            );

            if (vm.item.payment_method_code) {
              vm.paymentMethod = vm.company.payment_methods.find(
                (x) => x.code === vm.item.payment_method_code
              );
            }

            if (vm.company.country.country_setting) {
              vm.referenceCode = vm.company.credit_note_reference_codes.find(
                (x) => x.code === vm.item.debit_note_reference.reference_code
              );
              vm.selectDebitNoteReason(vm.referenceCode);
            }

            vm.user = vm.company.users.find((x) => x.id === vm.item.user_id);

            setDebitNoteProducts();
          }

          vm.loadingCompany = false;
        });
    }

    function setCompanyActivityCode(company) {
      if (!vm.atvCrEnabled) return;

      let activityCode = company.activity_codes.find((activityCode) => {
        return (
          activityCode.code === vm.item.company_activity_code ||
          activityCode.id === vm.item.company_activity_code_id
        );
      });

      vm.companyActivityCode = activityCode;
      vm.item.company_activity_code = activityCode.code;
    }

    function getDocumentTypes() {
      if (vm.documentTypes) return;

      let params = {
        get: 'active',
        transaction_type: 'client_debit_notes',
        skip_check_role: true,
      };

      vm.loadingDocumentTypes = true;
      DocumentTypeService.getDocumentTypes(params).then(function (data) {
        vm.documentTypes = data.items;

        // Preload default document type on create
        if (vm.createMode) {
          let defaultDocumentType = vm.documentTypes.find(
            (documentType) => documentType.is_default
          );

          vm.documentType = defaultDocumentType ? defaultDocumentType : vm.documentTypes[0];
          vm.item.document_type_id = vm.documentType.id;
        } else {
          vm.documentType = vm.documentTypes.find(
            (documentType) => documentType.id === vm.item.document_type_id
          );
          vm.isAnAutomaticNumberingType = vm.item.document_type.numbering_type === 'automatic';
        }

        vm.lastDocumentTypeId = vm.documentType.id;
        vm.lastDocumentType = vm.documentType;
        vm.item.document_type = vm.documentType;

        vm.isElectronicDocument = vm.documentType.numbering_type === 'electronic';

        setDebitNoteDatePicker(vm.documentType);

        vm.loadingDocumentTypes = false;
      });
    }

    function resetClientInput() {
      vm.item.client_id = null;
      vm.item.currency_id = null;
      vm.item.sale_condition_code = null;
      vm.item.credit_payment_days = null;
      vm.item.due_date = null;
      vm.item.transaction_id = null;
      vm.item.invoice_id = null;
      vm.item.credit_note_id = null;
      vm.item.reference_number = null;
      vm.item.reson = null;
      vm.item.invoice = null;
      vm.item.credit_note = null;

      if (vm.item.payment_method_code) {
        vm.item.payment_method_code = null;
        vm.item.payment_method_id = null;
      }

      vm.item.debit_note_products = []; // check
    }

    function calculateDebitNoteTotals() {
      let subtotal_services_taxable = 0;
      let subtotal_services_exempt = 0;
      let subtotal_services_exonerable = 0;
      let subtotal_goods_taxable = 0;
      let subtotal_goods_exempt = 0;
      let subtotal_goods_exonerable = 0;

      let total_sale = 0;
      let total_discount = 0;
      let total_net_sale = 0;
      let total_taxes = 0;
      let total_tax_exonerations = 0;
      let total_net_taxes = 0;
      let grand_total = 0;

      vm.item.debit_note_products.forEach(function (debit_note_product) {
        let total_amount = debit_note_product.total_amount;

        // if (debit_note_product.tax_amount > 0) {
        if (!debit_note_product.is_exempt) {
          if (
            debit_note_product.measurement_unit &&
            debit_note_product.measurement_unit.is_a_service
          ) {
            if (debit_note_product.tax_exoneration_amount > 0) {
              subtotal_services_taxable +=
                (1 -
                  (debit_note_product.tax_exoneration_percentage * 1) /
                    debit_note_product.tax_percentage) *
                total_amount;
              subtotal_services_exonerable += total_amount - subtotal_services_taxable;
            } else {
              subtotal_services_taxable += total_amount;
            }
          } else {
            if (debit_note_product.tax_exoneration_amount > 0) {
              subtotal_goods_taxable +=
                (1 -
                  (debit_note_product.tax_exoneration_percentage * 1) /
                    debit_note_product.tax_percentage) *
                total_amount;
              subtotal_goods_exonerable += total_amount - subtotal_goods_taxable;
            } else {
              subtotal_goods_taxable += total_amount;
            }
          }
        } else {
          if (
            debit_note_product.measurement_unit &&
            debit_note_product.measurement_unit.is_a_service
          ) {
            subtotal_services_exempt += total_amount;
          } else {
            subtotal_goods_exempt += total_amount;
          }
        }

        total_sale += debit_note_product.total_amount;
        total_discount += debit_note_product.discount_amount;
        total_net_sale += debit_note_product.subtotal_price;
        total_taxes += debit_note_product.tax_amount;
        total_tax_exonerations += debit_note_product.tax_exoneration_amount;
        total_net_taxes += debit_note_product.net_tax_amount;
        grand_total += debit_note_product.total_price;
      });

      // check these values with Pablo
      let total_taxable = subtotal_services_taxable + subtotal_goods_taxable;
      let total_exempt = subtotal_services_exempt + subtotal_goods_exempt;
      let total_exonerable = subtotal_services_exonerable + subtotal_goods_exonerable;
      let total_retornable_taxes = 0;
      let total_other_charges = 0;

      vm.item.subtotal_services_taxable = vm.UtilService.roundNum(subtotal_services_taxable);
      vm.item.subtotal_services_exempt = vm.UtilService.roundNum(subtotal_services_exempt);
      vm.item.subtotal_services_exonerable = vm.UtilService.roundNum(subtotal_services_exonerable);
      vm.item.subtotal_goods_taxable = vm.UtilService.roundNum(subtotal_goods_taxable);
      vm.item.subtotal_goods_exempt = vm.UtilService.roundNum(subtotal_goods_exempt);
      vm.item.subtotal_goods_exonerable = vm.UtilService.roundNum(subtotal_goods_exonerable);

      vm.item.total_taxable = vm.UtilService.roundNum(total_taxable);
      vm.item.total_exempt = vm.UtilService.roundNum(total_exempt);
      vm.item.total_exonerable = vm.UtilService.roundNum(total_exonerable);
      vm.item.total_sale = vm.UtilService.roundNum(total_sale);
      vm.item.total_discount = vm.UtilService.roundNum(total_discount);
      vm.item.total_net_sale = vm.UtilService.roundNum(total_net_sale);

      vm.item.total_taxes = vm.UtilService.roundNum(total_taxes);
      vm.item.total_tax_exonerations = vm.UtilService.roundNum(total_tax_exonerations);
      vm.item.total_net_taxes = vm.UtilService.roundNum(total_net_taxes);
      vm.item.total_retornable_taxes = vm.UtilService.roundNum(total_retornable_taxes);
      vm.item.total_other_charges = vm.UtilService.roundNum(total_other_charges);
      vm.item.grand_total = vm.UtilService.roundNum(grand_total);
      vm.item.balance_due = vm.item.grand_total;
    }

    // Remove unnecessary params
    function setDebitNoteParams() {
      let debitNote = angular.copy(vm.item);

      delete debitNote.currency;
      delete debitNote.client;
      delete debitNote.edit_allowed;

      debitNote.debit_note_products.forEach(function (product) {
        delete product.$$hashKey;
        delete product.measurement_unit;
        delete product.product;
      });

      return debitNote;
    }

    function getOpenInvoicesByClient(clientId) {
      let params = {
        get: 'open_invoices', // paid / accepted
        client_id: clientId,
        atvCrEnabled: vm.atvCrEnabled,
        by_reference_date: vm.item.date,
        skip_check_role: true,
      };

      vm.loadingTransactions = true;
      InvoiceService.getInvoices(params).then(function (data) {
        if (data.items.length) {
          vm.transactions = vm.transactions.concat(data.items);
        }

        vm.loadingTransactions = false;
      });
    }

    function getTransactions(clientId) {
      vm.transactions = [];

      getProcessedCreditNotesByClient(clientId);
      getOpenInvoicesByClient(clientId);
    }

    function getProcessedCreditNotesByClient(clientId) {
      let params = {
        get: 'processed_credit_notes', // Processed
        client_id: clientId,
        atvCrEnabled: vm.atvCrEnabled,
        by_reference_date: vm.item.date,
        skip_check_role: true,
      };

      vm.loadingTransactions = true;
      CreditNoteService.getCreditNotes(params).then(function (data) {
        if (data.items.length > 0) {
          vm.transactions = vm.transactions.concat(data.items);
        }

        vm.loadingTransactions = false;
      });
    }

    function setDebitNoteProducts() {
      vm.loadingDebitNoteProducts = false;

      if (vm.item.debit_note_products.length === 0) return;

      vm.allProductsCabysCodeSet = true;

      vm.item.debit_note_products.forEach(function (debitNoteProduct) {
        let measurementUnits = MeasurementUnitService.setMeasurementUnitsByProductType(
          vm.company.measurement_units,
          debitNoteProduct.product_type
        );

        let measurementUnit = measurementUnits.find(
          (item) => item.id === debitNoteProduct.measurement_unit_id
        );

        selectMeasurementUnit(debitNoteProduct, measurementUnit);

        if (vm.atvCrEnabled && vm.isElectronicDocument && !debitNoteProduct.product_cabys_code) {
          vm.allProductsCabysCodeSet = false;
        }
      });
    }

    function selectMeasurementUnit(debitNoteProduct, measurementUnit) {
      debitNoteProduct.measurement_unit = measurementUnit;
      debitNoteProduct.measurement_unit_symbol = measurementUnit.symbol;
    }

    function setDebitNoteDatePicker(documentType) {
      let minDate = documentType.allows_past_days ? false : moment();
      let maxDate = documentType.allows_future_days ? false : moment();

      let onChangeDate = () => {
        if (vm.editMode) {
          resetDebitNoteData();
        }
        getTransactions(vm.item.client_id);
      };

      vm.datePickerOptions = vm.UtilService.singleDatePickerOptions({
        minDate: minDate,
        maxDate: maxDate,
        dateDisplay: vm.dateDisplay,
        onChangeDate: onChangeDate,
      });
    }

    function resetDebitNoteData() {
      vm.item.transaction_id = null;
      vm.item.invoice_id = null;
      vm.item.credit_note_id = null;
      vm.item.reference_number = null;
      vm.item.reson = null;
      vm.item.debit_note_products = [];

      if (vm.item.invoice) {
        vm.item.invoice.invoice_number = null;
      } else {
        vm.item.credit_note.credit_note_number = null;
      }
    }
  }
})();
